import base from '../base';
export default {
	color: base.colors.primary,
	fontSize: 25,
	fontFamily: 'Titillium Web',
};
